function DateRelative (moment) {
  function filter (value) {
    if (!value) return null
    return moment(value).fromNow()
  }

  return {
    filter
  }
}

export default DateRelative
